import * as React from 'react';
import * as FileExtensions from '../FileExtensions';
import * as Features from '../../../../shared/Features';
import { Button, ButtonGroup, Col } from 'react-bootstrap';
import { Translate } from '../../../../shared/LanguageService';
import { IDelivery, ISelectedImage } from '../Entities';
import DeliveryFiles from './DeliveryFiles';
import openImage from '../ImageViewing';
import unknownIcon from '../../../../assets/images/mystery-file-icon.svg';
import pdfIcon from '../../../../assets/images/pdf-icon.svg';
import skpIcon from '../../../../assets/images/skp-icon.svg';
import psdIcon from '../../../../assets/images/psd-icon.svg';

interface IProps {
    stories: any;
    delivery: IDelivery;
    shouldGenerate: () => boolean;
    isGenerating: boolean;
    generate: () => void;
    approve: () => void;
    onSelectImage: (selectedImage: ISelectedImage, deliveryFileWasSelected: boolean) => void;
    canApprove?: () => boolean;
    isLocked: boolean;
    user: any;
    inActivateExternalFile: (planOrderExternalFileId: number) => void;
    deleteDeliveryFile: (fileReference: string) => void;
    annotateExternalFile?: (id: number) => void;
    annotateExternalDeliveryFile?: (id: number) => void;
    annotateDeliveryFile?: (id: number) => void;
}

const CheckDelivery = (props: IProps) => {
    const { apiUrl } = window.appConfig;

    return (
        <div>
            {props.delivery &&
                props.delivery.externalAnnotationFiles &&
                props.delivery.externalAnnotationFiles.length > 0 && (
                    <div>
                        <h2>{Translate('plan-order/delivery/external-annotation-files-title')}</h2>
                        <hr />
                        <div className="external-files-container">
                            {props.delivery.externalAnnotationFiles.map(
                                (externalAnnotationFile, index) => (
                                    <Col xs={6} sm={3} key={'delivery-external-' + index}>
                                        <fieldset>
                                            <legend />
                                            <div className="button-bar-below">
                                                <p className="limit-width">
                                                    {externalAnnotationFile.filename}
                                                </p>
                                                {externalAnnotationFile.fileType ===
                                                    FileExtensions.unknown && (
                                                    <img className="pdf-icon" src={unknownIcon} />
                                                )}
                                                {externalAnnotationFile.fileType ===
                                                    FileExtensions.pdf && (
                                                    <img className="pdf-icon" src={pdfIcon} />
                                                )}
                                                {externalAnnotationFile.fileType ===
                                                    FileExtensions.psd && (
                                                    <img className="pdf-icon" src={psdIcon} />
                                                )}
                                                {externalAnnotationFile.fileType ===
                                                    FileExtensions.skp && (
                                                    <img className="pdf-icon" src={skpIcon} />
                                                )}
                                                {(externalAnnotationFile.fileType ===
                                                    FileExtensions.jpg ||
                                                    externalAnnotationFile.fileType ===
                                                        FileExtensions.png) && (
                                                    <div className="content-row">
                                                        <img
                                                            onClick={() =>
                                                                openImage(externalAnnotationFile)
                                                            }
                                                            src={`${apiUrl}/file/${externalAnnotationFile.thumbnailReference}`}
                                                        />
                                                    </div>
                                                )}
                                                {(externalAnnotationFile.fileType ===
                                                    FileExtensions.jpg ||
                                                    externalAnnotationFile.fileType ===
                                                        FileExtensions.png) &&
                                                    !props.isLocked && (
                                                        <div className="button-row">
                                                            <ButtonGroup bsSize="sm">
                                                                <Button
                                                                    bsStyle="info"
                                                                    title={Translate(
                                                                        'order/plan/storey/annotate-button'
                                                                    )}
                                                                    onClick={() =>
                                                                        props.annotateExternalFile(
                                                                            externalAnnotationFile.planOrderExternalFileId
                                                                        )
                                                                    }
                                                                >
                                                                    <i className="material-icons no-label">
                                                                        mode_edit
                                                                    </i>
                                                                </Button>
                                                                <a
                                                                    className="btn btn-info"
                                                                    title={Translate(
                                                                        'order/plan/exernal-annotation-file/download-button'
                                                                    )}
                                                                    href={`${apiUrl}/file/${externalAnnotationFile.fileReference}`}
                                                                    target="_blank"
                                                                >
                                                                    <i className="material-icons md-18">
                                                                        cloud_download
                                                                    </i>
                                                                </a>
                                                                {Features.hasFeature(
                                                                    Features.DeleteExternalFile,
                                                                    props.user
                                                                ) && (
                                                                    <Button
                                                                        bsStyle="danger"
                                                                        title={Translate(
                                                                            'order/plan/storey/delete-button'
                                                                        )}
                                                                        onClick={() =>
                                                                            props.inActivateExternalFile(
                                                                                externalAnnotationFile.planOrderExternalFileId
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="material-icons no-label md-18">
                                                                            delete_forever
                                                                        </i>
                                                                    </Button>
                                                                )}
                                                            </ButtonGroup>
                                                        </div>
                                                    )}
                                                {externalAnnotationFile.fileType !==
                                                    FileExtensions.jpg &&
                                                    externalAnnotationFile.fileType !==
                                                        FileExtensions.png && (
                                                        <div>
                                                            <a
                                                                className="btn btn-default"
                                                                href={`${apiUrl}/file/${externalAnnotationFile.fileReference}`}
                                                                target="_blank"
                                                            >
                                                                {Translate(
                                                                    'order/plan/delivery/download-external-annotation-file/agent'
                                                                )}
                                                            </a>
                                                        </div>
                                                    )}
                                            </div>
                                        </fieldset>
                                    </Col>
                                )
                            )}
                        </div>
                    </div>
                )}

            {(props.shouldGenerate() || props.delivery) && (
                <div>
                    <h2>{Translate('plan-order/delivery/title')}</h2>
                    <hr />
                    <DeliveryFiles
                        delivery={props.delivery}
                        readOnly={props.isLocked}
                        user={props.user}
                        onClickImage={(
                            selectedImage: ISelectedImage,
                            deliveryFileWasSelected: boolean
                        ) => props.onSelectImage(selectedImage, deliveryFileWasSelected)}
                        deleteDeliveryFile={props.deleteDeliveryFile}
                        annotateExternalDeliveryFile={props.annotateExternalDeliveryFile}
                        annotateDeliveryFile={props.annotateDeliveryFile}
                    />
                </div>
            )}
        </div>
    );
};

export default CheckDelivery;
